module.exports = __webpack_public_path__ + "img/bloodthirster_small.3e700d66.png";